import {useQuery} from '@tanstack/react-query';
import {useRestAPI} from '@resurs-internal/rb-app-api';
import {useCountryParam} from './useCountryParam';
import {config} from '../config';
import {useSessionState} from './useSessionState';

export interface Banner {
  id: string;
  title?: string;
  text?: string;
  variant?: 'success' | 'info' | 'warning' | 'error';
  countries: string[];
  platform: string[];
  updatedAt: string;
  createdAt: string;
}

export const useBanner = () => {
  const api = useRestAPI();

  const {country} = useCountryParam();
  const [dismissId, setDismissId] = useSessionState('dismiss-banner');

  const query = useQuery({
    queryKey: ['banner', country.code],
    queryFn: async () => {
      const url = new URL(`${config.customerFrontendService}/public/banner`);
      url.searchParams.set('country', country.code);
      url.searchParams.set('platform', 'WEB');
      const response = await api.client.getJSONBody<Banner>(`${url}`);
      return response ?? null;
    },
  });

  const show = Boolean(query.data?.title) && query.data?.id !== dismissId;
  const dismiss = () => setDismissId(query.data?.id);

  return {
    query,
    show,
    dismiss,
  };
};
